import {Component, inject, Input} from '@angular/core';
import {Router} from '@angular/router';
import {ActiveModal} from '../../modal';
import {NgClass} from '@angular/common';
import {TranslatePipe} from "@ngx-translate/core";
import {IconComponent} from "../icon/icon.component";

@Component({
    selector: 'app-applied-coupon-modal',
    templateUrl: './applied-coupon-modal.component.html',
    styleUrls: ['./applied-coupon-modal.component.scss'],
    standalone: true,
    imports: [TranslatePipe, NgClass, IconComponent]
})
export class AppliedCouponModalComponent {
    @Input() success: boolean = true;
    @Input() discountValue?: string;

    activeModal = inject(ActiveModal);
    private router = inject(Router);

    navigateToSubscription(): void {
        this.activeModal.dismiss();
        this.router.navigate(['/page/subscription']);
    }

    close(): void {
        this.activeModal.dismiss();
    }
}
